import { Component } from "@angular/core";

import { Platform } from "@ionic/angular";
import { LoggingService } from "./services/logging.service";

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    styleUrls: ["app.component.scss"],
})
export class AppComponent {
    constructor(
        private platform: Platform,
        private loggingService: LoggingService,
    ) {
        this.initializeApp();
        this.loggingService.log(
            "%cversion: " + require("../../package.json").version,
            true,
            "color: white; font-weight: bold; background: #262E48; padding: 8px 12px;"
        );
    }

    initializeApp() {
        this.platform.ready().then(() => {
        });
    }
}
